import React from 'react'
import Collapse from '@material-ui/core/Collapse'

import BkFlowRoomCardRateStagePriceCollection from '../../multi-stage/BkFlowRoomCardRateStagePriceCollection'
import BkFlowRoomCardRateStagePriceButton from '../../multi-stage/BkFlowRoomCardRateStagePriceButton'

import yn from 'yn'

const BkFlowRoomCardDynamicRatesAccordion = props => {
  const {
    activeCurrencyData,
    cards,
    currentRateCode,
    currentUpSells,
    isTaxInclusiveProperty,
    ratePlanData,
    roomGroup,
    roomRateStageExpanded,
    toggleActiveRoom,
    totalNights,
    upSellsToggleEvent,
  } = props

  let renderRoomPriceSections = []

  if (
    cards &&
    cards.viewExtensions &&
    cards.viewExtensions.roomRates &&
    yn(process.env.REACT_APP_COMPONENT_ENABLE_PARENT_CHILD_RATE_SORTING)
  ) {
    const roomRates = cards.viewExtensions.roomRates
    let parentRoomRates = [],
        childRoomRates = []

    // Construct arrays of parent and children roomRates based on viewExtension existing
    for (const rateKey in roomRates) {
      let hasParentRate = false

      const roomRate = roomRates[rateKey]

      if (
        roomRate &&
        roomRate.viewExtensions &&
        roomRate.viewExtensions.parentRatePlanCode
      ) {
        hasParentRate = true
      }

      if (hasParentRate) {
        childRoomRates.push(roomRate)
      } else {
        parentRoomRates.push(roomRate)
      }
    }

    // Display parent rates, and pass applicable child roomRate & ratePlan to parent component
    for (const rateKey in parentRoomRates) {
      const parentRoomRate = parentRoomRates[rateKey],
        parentRatePlan = ratePlanData.filter(function(rate) {
          return rate.ratePlanCode === parentRoomRate.ratePlanCode
        }),
        childRoomRate = childRoomRates.filter(function(rate) {
          return rate.viewExtensions.parentRatePlanCode === parentRoomRate.ratePlanCode && rate.roomTypeCode === parentRoomRate.roomTypeCode
        })

      let childRatePlan = null

      if (
        childRoomRate &&
        childRoomRate[0]
      ) {
        childRatePlan = ratePlanData.filter(function(rate) {
          return rate.ratePlanCode === childRoomRate[0].ratePlanCode
        })
      }

      if (
        childRoomRate &&
        childRoomRate[0] &&
        childRatePlan &&
        childRatePlan[0]
      ) {
        renderRoomPriceSections.push(
          <BkFlowRoomCardRateStagePriceCollection
            key={ parentRoomRate.ratePlanCode }
            activeCurrencyData={activeCurrencyData}
            currentRateCode={currentRateCode}
            currentUpSells={currentUpSells}
            totalNights={totalNights}
            roomGroup={roomGroup}
            roomRateData={parentRoomRate}
            ratePlanData={parentRatePlan[0]}
            toggleActiveRoom={toggleActiveRoom}
            childRoomRateData={childRoomRate && childRoomRate[0] && childRoomRate[0]}
            childRatePlanData={childRatePlan && childRatePlan[0] && childRatePlan[0]}
            upSellsToggleEvent={(roomTypeCode, roomRateCode) => upSellsToggleEvent(roomTypeCode, roomRateCode)}
          />
        )
      } else {
        renderRoomPriceSections.push(
          <BkFlowRoomCardRateStagePriceButton
            key={ parentRoomRate.ratePlanCode }
            activeCurrencyData={activeCurrencyData}
            currentRateCode={currentRateCode}
            currentUpSells={currentUpSells}
            isTaxInclusiveProperty={isTaxInclusiveProperty}
            totalNights={totalNights}
            roomGroup={roomGroup}
            roomRateData={parentRoomRate}
            ratePlanData={parentRatePlan[0]}
            toggleActiveRoom={toggleActiveRoom}
            upSellsToggleEvent={(roomTypeCode, roomRateCode) => upSellsToggleEvent(roomTypeCode, roomRateCode)}
          />
        )
      }
    }
  } else if (
    cards &&
    cards.viewExtensions &&
    cards.viewExtensions.roomRates
  ) {
    const roomRates = cards.viewExtensions.roomRates

    for (const rateKey in roomRates) {
      const roomRate = roomRates[rateKey],
        roomRatePlan = ratePlanData.filter(function(rate) {
          return rate.ratePlanCode === roomRate.ratePlanCode
        })

      renderRoomPriceSections.push(
        <BkFlowRoomCardRateStagePriceButton
          key={ roomRate.ratePlanCode }
          activeCurrencyData={activeCurrencyData}
          currentRateCode={currentRateCode}
          currentUpSells={currentUpSells}
          isTaxInclusiveProperty={isTaxInclusiveProperty}
          totalNights={totalNights}
          roomGroup={roomGroup}
          roomRateData={roomRate}
          ratePlanData={roomRatePlan[0]}
          toggleActiveRoom={toggleActiveRoom}
          upSellsToggleEvent={(roomTypeCode, roomRateCode) => upSellsToggleEvent(roomTypeCode, roomRateCode)}
        />
      )
    }
  }

  return (
    <Collapse
      in={roomRateStageExpanded}
      timeout={300}
    >
      {renderRoomPriceSections &&
        <div className="bk-flow-room__dynamic-rates-accordion">
          { renderRoomPriceSections }
        </div>
      }
    </Collapse>
  )
}

export default BkFlowRoomCardDynamicRatesAccordion



// WEBPACK FOOTER //
// ./src/components/room/elements/default/dynamic/BkFlowRoomCardDynamicRatesAccordion.js